<div style="position: sticky;top:25%">
<app-spinner-overlay [showSpinner]="showSpinner"></app-spinner-overlay>
<app-spinner-overlay [showSpinner]="showSpinnerWithMessage" [subText]="subText"></app-spinner-overlay>
<div class="loading-overlay" *ngIf="loading"> <div class="spinner"></div>
</div>
</div>